// extracted by mini-css-extract-plugin
export var active = "_eg-2";
export var recordingDot = "_eg-1";
export var recordingIndicator = "_eg-0";